<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- ticket-icons.component -->
<!-- The pin icon circle should only show up if the ticket has a pin -->
<div
	class="pin-icon-circle"
	*ngIf="totalPins > 0"
	[ngStyle]="{ background: color }"
	(click)="onIconClicked($event)"
	automationId="pinIconCircle"
>
	<img src="assets/images/promise_pin.svg" />
	<!-- The pin count badge should only show up if the ticket has more than one pin -->
	<div class="pin-count-badge" *ngIf="missedCount > 0">
		<!-- I'd like to limit the character count here with code, perhaps to 2 characters? ex. 9+ is where it would stop if more than 9 pins -->
		<div class="pin-count" automationId="pinCount">{{ missedCount }}</div>
	</div>
</div>
